import * as React from "react";
import { FormControl } from "react-bootstrap";
import { AbstractQuestion } from "./AbstractQuestion";
import { SingleValueQuestionProps } from "./QuestionProps";
import { QuestionRow } from "./QuestionRow";

export class MultiLineTextQuestion extends AbstractQuestion<
  SingleValueQuestionProps,
  {}
> {
  render() {
    const q = this.props.question;

    return (
      <QuestionRow
        label={q.label}
        required={q.isRequired}
        errorText={q.errorText}
        visible={q.isVisible()}
        helpText={q.helpText}
        validationState={
          q.isValid() || !this.showValidationState ? null : "error"
        }
      >
        <FormControl
          componentClass="textarea"
          name={q.name}
          defaultValue={q.answer}
          onChange={this.onChange}
          onBlur={this.onBlur}
          placeholder={q.placeholder}
        />
        <FormControl.Feedback />
      </QuestionRow>
    );
  }
}
